import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5791ceea&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5791ceea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5791ceea')) {
      api.createRecord('5791ceea', component.options)
    } else {
      api.reload('5791ceea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5791ceea&scoped=true&", function () {
      api.rerender('5791ceea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberArea/index.vue"
export default component.exports